const actions = {
  GET_STATISTICS_DATA_REPORT_RESULT: 'GET_STATISTICS_DATA_REPORT_RESULT',
  GET_STATISTICS_DATA_REPORT_RESULT_ENDED: 'GET_STATISTICS_DATA_REPORT_RESULT_ENDED',
  TRIGGER_UPDATE_STATISTICS_DATA_REPORT: 'TRIGGER_UPDATE_STATISTICS_DATA_REPORT',
  TRIGGER_UPDATE_STATISTICS_DATA_REPORT_ENDED: 'TRIGGER_UPDATE_STATISTICS_DATA_REPORT_ENDED',
};

export default actions;
